import Auth from "../services/Auth";
import Notifications from "../services/Notifications";

const actions = {

  // ////////////////////////////////////////////
  // SIDEBAR & UI UX
  // ////////////////////////////////////////////

  me({commit}, payload) {
    return new Promise((resolve, reject) => {
      Auth.me(payload).then((response) => {
          commit('ME', response.data);
          resolve(response.data);
        },
        error => reject(error));
    })
  },
  login({commit}, payload) {
    return new Promise((resolve, reject) => {
      Auth.login(payload).then((response) => {
          commit('LOGIN', response.token);
          resolve();
        },
        error => reject(error));
    })
  },
  logout({commit}) {
    commit('LOGOUT');
  },
  updateSidebarWidth({commit}, width) {
    commit('UPDATE_SIDEBAR_WIDTH', width);
  },
  toggleContentOverlay({commit}) {
    commit('TOGGLE_CONTENT_OVERLAY');
  },
  updateTheme({commit}, val) {
    commit('UPDATE_THEME', val);
  },
  updateWindowWidth({commit}, width) {
    commit('UPDATE_WINDOW_WIDTH', width);
  },


  // ////////////////////////////////////////////
  // COMPONENT
  // ////////////////////////////////////////////

  // VxAutoSuggest
  updateStarredPage({commit}, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  //  The Navbar
  arrangeStarredPagesLimited({commit}, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore({commit}, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  getUnreadNotifications({commit}) {
    return new Promise((resolve, reject) => {
      Notifications.getUnreadNotifications().then((notifications) => {
        commit('UNREAD_NOTIFICATIONS', notifications);
        resolve(notifications);
      }, error => reject(error));
    });
  },

  markNotificationAsRead({commit}, notification) {
    return new Promise((resolve, reject) => {
      commit('MARK_AS_READ', notification);
      Notifications.markAsRead(notification).then(() => {
        resolve();
      }, error => reject(error));
    });
  },

  markAllNotificationsAsRead ({commit}) {
    return new Promise((resolve, reject) => {
      commit('MARK_ALL_AS_READ');
      Notifications.markAllAsRead().then(() => {
        resolve();
      }, error => reject(error));
    });
  }
}

export default actions
